<view-icons *ngIf="mode === 'icons'" [items]="items" [object]="object"></view-icons>

<view-menu *ngIf="mode === 'menu'" [items]="items" [object]="object">
  <ng-content></ng-content>
</view-menu>

<view-data-list
  *ngIf="mode === 'data-list'"
  [items]="items"
  [object]="object"
  (clicked)="clicked.emit()"
></view-data-list>
